import React, { useContext, useCallback, useEffect } from 'react';
import { Input, Button, Form } from 'antd';
import { FiltersContext } from '@CONTEXTS';
import MaskedInput from 'antd-mask-input';

const Filters = () => {
  const { dispatch, filters } = useContext(FiltersContext);

  const setFilters = useCallback(
    (obj) => {
      dispatch({
        type: 'SET_FILTERS',
        payload: obj,
      });
    },
    [dispatch]
  );

  const onFinish = (values) => {
    const { firstName, lastName, phone } = values;
    const obj = {
      firstName,
      lastName,
      phone: phone?.replace(/ /g, ''),
    };
    setFilters(obj);
  };

  useEffect(() => {
    resetFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const resetFilters = () => {
    dispatch({
      type: 'SET_FILTERS',
      payload: { firstName: null, lastName: null, phone: null },
    });
  };

  return (
    <Form layout="inline" onFinish={(values) => onFinish(values)}>
      <Form.Item label={null} name="firstName" style={{ width: 260 }}>
        <Input
          placeholder="Ad"
          allowClear
          onChange={(e) => {
            const { value } = e.target;
            const { phone, lastName } = filters;
            // value yoksa (çarpı butonuna tıklanmışsa) ve barkod değeri yoksa otomatik tekrar arasın
            if (
              value === '' &&
              (phone === '' || phone === null || phone === undefined) &&
              (lastName === '' || lastName === null || lastName === undefined)
            ) {
              resetFilters();
            }
          }}
        />
      </Form.Item>
      <Form.Item label={null} name="lastName" style={{ width: 260 }}>
        <Input
          placeholder="Soyad"
          allowClear
          onChange={(e) => {
            const { value } = e.target;
            const { phone, firstName } = filters;
            // value yoksa (çarpı butonuna tıklanmışsa) ve barkod değeri yoksa otomatik tekrar arasın
            if (
              value === '' &&
              (phone === '' || phone === null || phone === undefined) &&
              (firstName === '' ||
                firstName === null ||
                firstName === undefined)
            ) {
              resetFilters();
            }
          }}
        />
      </Form.Item>
      <Form.Item label={null} name="phone" style={{ width: 260 }}>
        <MaskedInput
          mask="111 111 11 11"
          size="10"
          placeholder="Telefon"
          allowClear
          onChange={(e) => {
            const { value } = e.target;
            const { firstName, lastName } = filters;
            // value yoksa (çarpı butonuna tıklanmışsa) ve sipariş numarası değeri yoksa otomatik tekrar arasın
            if (
              value === '' &&
              (firstName === '' ||
                firstName === null ||
                firstName === undefined) &&
              (lastName === '' || lastName === null || lastName === undefined)
            ) {
              resetFilters();
            }
          }}
        />
      </Form.Item>

      <Form.Item style={{ width: 135 }}>
        <Button type="primary" block htmlType="submit">
          Ara
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Filters;
